<p-button [link]="true" size="small" severity="secondary" (onClick)="onToggleTheme()"
[icon]="isDarkTheme() ? 'pi pi-sun' : 'pi pi-moon'"

>
  </p-button>
  